import {fromJS} from 'immutable';

import {
  SET_DELIVERY_PLACE,
  GET_ORDERS_REQUEST,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
  CHECK_ORDER_REQUEST,
  CHECK_ORDER_SUCCESS,
  CHECK_ORDER_FAILURE,
  GET_ORDER_DETAILS_REQUEST,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_DETAILS_FAILURE,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  UPDATE_PAYMENT_METHOD_ORDER_REQUEST,
  UPDATE_PAYMENT_METHOD_ORDER_SUCCESS,
  UPDATE_PAYMENT_METHOD_ORDER_FAILURE,
  SHIPPO_SHIPMENT_REQUEST,
  SHIPPO_SHIPMENT_SUCCESS,
  SHIPPO_SHIPMENT_FAILURE,

} from '../actions/ordersActions';

// Initial state
const initialState = fromJS({loading: false, error: {}, deliveryPlace: false, recentOrder: false, shippoLoading: false});

// Reducer
export default function OrdersReducer(state = initialState, action = {}) {

  switch (action.type) {

    case GET_ORDERS_REQUEST:
    case CHECK_ORDER_REQUEST:
    case PLACE_ORDER_REQUEST:
    case UPDATE_PAYMENT_METHOD_ORDER_REQUEST:
      return state.set('error', false).set('loading', true);
    case SHIPPO_SHIPMENT_REQUEST:
      return state.set('shippoLoading', true);

    case CHECK_ORDER_SUCCESS:
    case PLACE_ORDER_SUCCESS:
      return state.set('loading', false).set('recentOrder', action.payload.orderId);

    case GET_ORDER_DETAILS_REQUEST:
      return state.set('error', false).set('loading', true).set('recentOrder', false);

    case GET_ORDERS_SUCCESS:
      return state.set('orders', action.payload).set('loading', false);

    case GET_ORDER_DETAILS_SUCCESS:
      return state.set('recentOrder', action.payload).set('loading', false);
    
    case UPDATE_PAYMENT_METHOD_ORDER_SUCCESS:
      return state.set('error', false).set('loading', false);

    case GET_ORDERS_FAILURE:
    case CHECK_ORDER_FAILURE:
    case GET_ORDER_DETAILS_FAILURE:
    case PLACE_ORDER_FAILURE:
    case UPDATE_PAYMENT_METHOD_ORDER_FAILURE:
        return state.set('error', action.payload).set('loading', false);

    case SHIPPO_SHIPMENT_SUCCESS:
    case SHIPPO_SHIPMENT_FAILURE:
      return state.set('shippoLoading', false);

    case SET_DELIVERY_PLACE:
      return state.set('deliveryPlace', action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ordersReducer.js